import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const usd = (n) =>
  typeof n === "number"
    ? n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 })
    : "$0";

// Worldwide-friendly money formatter using a plain currency symbol.
export const money = (n, symbol = "$") => {
  if (typeof n !== "number" || isNaN(n)) return `${symbol}0`;
  return `${symbol}${Math.round(n).toLocaleString("en-US")}`;
};

export const mediaUrl = (rel) => (rel ? `${BACKEND_URL}${rel}` : null);

export function getAnonId() {
  let id = localStorage.getItem("bf_anon_id");
  if (!id) {
    id = "anon_" + (crypto?.randomUUID?.() || Math.random().toString(36).slice(2));
    localStorage.setItem("bf_anon_id", id);
  }
  return id;
}
